export function registerServiceWorker() {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          console.log('[PWA] ServiceWorker registered with scope:', reg.scope);
        })
        .catch((err) => {
          console.warn('[PWA] ServiceWorker registration failed:', err);
        });
    });
  } else if ('serviceWorker' in navigator) {
    // Also register in dev mode if needed, or allow registration
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          console.log('[PWA] ServiceWorker registered (dev):', reg.scope);
        })
        .catch((err) => {
          console.warn('[PWA] ServiceWorker registration failed (dev):', err);
        });
    });
  }
}
